import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const DiscordIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fill="currentColor"
			d="M13.2064 3.005C12.2355 2.5355 11.1972 2.19429 10.1118 2C9.97851 2.24907 9.82277 2.58408 9.7154 2.85057C8.56156 2.67124 7.41834 2.67124 6.28572 2.85057C6.17837 2.58408 6.0191 2.24907 5.8846 2C4.798 2.19429 3.7586 2.53675 2.78762 3.00748C0.829152 6.06602 0.298243 9.04858 0.563698 11.9888C1.86266 12.9913 3.12151 13.6003 4.35911 13.9988C4.66468 13.5641 4.93721 13.1021 5.17199 12.6152C4.72485 12.4396 4.29658 12.2229 3.89192 11.9714C3.99928 11.8892 4.10429 11.8032 4.20574 11.7148C6.67387 12.9079 9.35556 12.9079 11.7942 11.7148C11.8969 11.8032 12.0018 11.8892 12.108 11.9714C11.7022 12.2242 11.2727 12.4408 10.8256 12.6165C11.0604 13.1021 11.3317 13.5654 11.6385 14C12.8773 13.6015 14.1373 12.9925 15.4362 11.9888C15.7477 8.58034 14.9042 5.62516 13.2064 3.005ZM5.50824 10.1806C4.76733 10.1806 4.15972 9.46576 4.15972 8.59528C4.15972 7.72479 4.75435 7.00873 5.50824 7.00873C6.26214 7.00873 6.86972 7.72354 6.85675 8.59528C6.85792 9.46576 6.26214 10.1806 5.50824 10.1806ZM10.4917 10.1806C9.7508 10.1806 9.1432 9.46576 9.1432 8.59528C9.1432 7.72479 9.73781 7.00873 10.4917 7.00873C11.2456 7.00873 11.8532 7.72354 11.8402 8.59528C11.8402 9.46576 11.2456 10.1806 10.4917 10.1806Z"
		></path>
	</svg>
))
